import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getInitialActiveCard, setSessionActiveCard } from "../../utilities/common";

const initialState = {
  loader: false,
  generateModel: false,
  selectModel: false,
  draftModel: false,
  workBenchName: "",
  embeddingName: "",
  countGeneratedModels: 0,
  generatedList: Array<{ id: string;[key: string]: any }>(),
  draftList: [],
  selectedKeys: [],
  checkedList: {
    dataExplorer: [],
    report: [],
    semantic: [],
    draft_semantic: [],
  },
  selectedAction: "",
  profileName: "",
  profileImage: "",
  modelTypeFromWorkbench: "",
  workbenchZoomLevel: 0.5,
  searchText: "",
  SemanticModelName: "",
  semanticSecretKey: "",
  showConnExpiredModal: false,
  activeCard: getInitialActiveCard(),
  inviteUserModal: false,
  inviteWorkbenchUserModal: false,
  dashboardModalsOpens: false,
  workbenchPermission: null,
  isAdmin: false,
  listofDisplayItems: null,

};

const userSlice = createSlice({
  name: "statics",
  initialState,
  reducers: {
    // Fixed editModel reducer with proper null checking
    editModel: (state, action) => {
      const { id, data } = action.payload;

      // Safely handle the generatedList
      if (state.generatedList && Array.isArray(state.generatedList)) {
        state.generatedList = state.generatedList.map((item: { id: string;[key: string]: any }) =>
          item.id === id ? { ...item, ...data } : item
        );
      } else {
        // Initialize the array if it doesn't exist
        state.generatedList = [];
        console.warn('GeneratedList was undefined or not an array when editing model');
      }
    },

    loader: (state, action) => {
      state.loader = action.payload;
    },
    setGenerateModel: (state: any, action: PayloadAction<boolean>) => {
      state.generateModel = action.payload;
    },
    setDraftModel: (state: any, action: PayloadAction<boolean>) => {
      state.draftModel = action.payload;
    },
    setWorkBenchName: (state: any, action: PayloadAction<any>) => {
      state.workBenchName = action.payload;
    },
    setEmbedingName: (state: any, action: PayloadAction<any>) => {
      state.embeddingName = action.payload;
    },
    updateCountGeneratedModels: (state) => {
      state.countGeneratedModels = state.countGeneratedModels + 1;
    },
    setSemanticModelName: (state: any, action: PayloadAction<string>) => {
      state.SemanticModelName = action.payload;
    },
    setSemanticSecretKey: (state: any, action: PayloadAction<string>) => {
      state.semanticSecretKey = action.payload;
    },
    setShowConnectionExpiredModal: (state: any) => {
      state.showConnExpiredModal = true
    },
    setHideConnectionExpiredModel: (state: any) => {
      state.showConnExpiredModal = false;
    },
    updateInitialGeneratedModels: (state, action) => {
      state.generatedList = action.payload;
    },

    updateInitialDraftModels: (state, action) => {
      state.draftList = action.payload;
    },

    /*     editModel: (state: any, action) => {
          const { id, data } = action.payload;
          state.list = state.list.map((item: any) =>
            item.id === id ? { ...item, ...data } : item
          );
        }, */

    setSelectModel: (state: any, action: PayloadAction<boolean>) => {
      state.selectModel = action.payload
    },

    clearCheckedList: (state) => {
      state.checkedList = {
        dataExplorer: [],
        report: [],
        semantic: [],
        draft_semantic: [],
      };
    },

    setSelectedKeys: (state, action) => {
      state.selectedKeys = action.payload;
    },

    setProfileName: (state: any, action: PayloadAction<string>) => {
      state.profileName = action.payload
    },

    setProfileImage: (state: any, action: any) => {
      state.profileImage = action.payload
    },

    setModelTypeFromWorkbench: (state: any, action: PayloadAction<string>) => {
      state.modelTypeFromWorkbench = action.payload
    },

    setWorkbenchZoomLevel: (state: any, action: any) => {
      state.workbenchZoomLevel = action.payload
    },

    setSearchText: (state, action: PayloadAction<string>) => {
      state.searchText = action.payload;
    },

    setInviteUserModal: (state: any, action: PayloadAction<boolean>) => {
      state.inviteUserModal = action.payload;
    },

    setInviteWorkbenchUserModal: (state: any, action: PayloadAction<boolean>) => {
      state.inviteWorkbenchUserModal = action.payload;
    },

    setDashboardModalsOpens: (state: any, action: PayloadAction<boolean>) => {
      state.dashboardModalsOpens = action.payload;
    },

    setWorkbenchPermission: (state: any, action: PayloadAction<number>) => {
      state.workbenchPermission = action.payload;
    },

    setIsAdmin: (state: any, action: PayloadAction<boolean>) => {
      state.isAdmin = action.payload;
    },
    setCheckedList: (state: any, action) => {
      const { id, checked, view } = action.payload;
      const listKey =
        view === "Data Explorer"
          ? "dataExplorer"
          : view === "My Reports"
            ? "report"
            : view === 'draft_semantic'
              ? 'draft_semantic'
              : 'semantic';

      if (checked) {
        if (!state.checkedList[listKey].includes(id)) {
          state.checkedList[listKey].push(id);
        }
      } else {
        state.checkedList[listKey] = state.checkedList[listKey].filter((itemId: string) => itemId !== id);
      }
    },
    setActiveCard: (state: any, action: PayloadAction<string>) => {
      state.activeCard = action.payload;
      setSessionActiveCard(action.payload);
    },
    setDisplayItems: (state: any, action: PayloadAction<any>) => {
      state.listofDisplayItems = action.payload;
    },
    setSelectedAction: (state: any, action: PayloadAction<string | null>) => {
      state.selectedAction = action.payload
    },
  },
});
export const {
  loader,
  setGenerateModel,
  setDraftModel,
  setSelectModel,
  setWorkBenchName,
  setEmbedingName,
  updateCountGeneratedModels,
  updateInitialGeneratedModels,
  updateInitialDraftModels,
  editModel,
  setSelectedKeys,
  setProfileName,
  setProfileImage,
  setModelTypeFromWorkbench,
  setWorkbenchZoomLevel,
  setSearchText,
  setSemanticModelName,
  setSemanticSecretKey,
  setShowConnectionExpiredModal,
  setHideConnectionExpiredModel,
  setInviteUserModal,
  setInviteWorkbenchUserModal,
  setDashboardModalsOpens,
  setWorkbenchPermission,
  setIsAdmin,
  setCheckedList,
  setDisplayItems,
  setSelectedAction,
  clearCheckedList,
  setActiveCard
} = userSlice.actions;
export default userSlice.reducer;
